import { createRouter, createWebHashHistory } from 'vue-router'
import { setupRouterGuards } from './guards'
import { basicRoutes } from './basic-routes'
import type { App } from 'vue'

// 创捷路由
export const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_PUBLIC_PATH || '/'),
  routes: basicRoutes,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

// 安装路由
export async function setupRouter(app: App) {
  // 安装路由
  setupRouterGuards(router)
  app.use(router)
}
